import styled from "styled-components";


export const ReportMain = styled.div`
  color: black;
  padding: 2rem;
`;